import React, { lazy } from 'react'
import type { RouteObject } from 'react-router'

const Answer = lazy(() => import('./Answer'))
const Browse = lazy(() => import('./Browse'))

const routes: RouteObject[] = [
    {
        path: '/safety-questionnaires',
        element: <Browse />
    },
    {
        path: '/safety-questionnaires/answer/:quizId',
        element: <Answer />
    },
    {
        path: '/safety-questionnaires/view/:quizId',
        element: <Answer />
    }
]

export default routes
